import axios, { AxiosResponse } from 'axios';

import { HSCAN_BACKEND_API_URL } from '../../env';

import { PAYMENT_STATUS, PriceDetail } from './hospital';

export interface RequestOnlinePaymentConsentBody {
  uuid: string;
}
export interface OnlinePaymentContent {
  studyInstanceUID: string;
  modality: string;
  /**
   * yyyy-MM-dd
   */
  studyDate: string;
  /**
   * Bytes
   */
  fileSize: number;
  numberOfFiles: number;
}
export interface OnlinePayment {
  id: string;
  price: PriceDetail;
  paymentStatus: PAYMENT_STATUS;
  hospitalName: string;
  content: OnlinePaymentContent;
}
export const requestOnlinePaymentConsent = ({
  uuid,
}: RequestOnlinePaymentConsentBody) => {
  return axios.post<
    OnlinePayment,
    AxiosResponse<OnlinePayment>,
    RequestOnlinePaymentConsentBody
  >(`${HSCAN_BACKEND_API_URL}/online-payment-consent/payment`, {
    uuid,
  });
};

export interface VerifyOnlinePaymentConsentParams {
  paymentId: string;
}
export const verifyOnlinePaymentConsent = ({
  paymentId,
}: VerifyOnlinePaymentConsentParams) => {
  return axios.put(
    `${HSCAN_BACKEND_API_URL}/online-payment-consent/payment/${paymentId}`,
    undefined,
  );
};
